import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left side */}
        <div className="footer-left">
          <h3>MediMetrics</h3>
          <p>Making medical measurements accessible worldwide.</p>
        </div>

        {/* Center logo */}
        <div className="footer-center">
          <img
            src={require("./assets/MM-No-Background.png")} 
            alt="MediMetrics Logo"
            className="footer-logo"
          />
        </div>

        {/* Right side links */}
        <div className="footer-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} MediMetrics. All rights reserved.</p>
      </div>
    </footer>
  );
}